import React from "react"
import { SchoolOutlined } from "@mui/icons-material"

/**
 * The institution's classes. A vertical list beside the content on wide
 * screens; a horizontally scrolling strip of pills on narrow ones.
 *
 * `getMeta(item)` may return a short caption shown under the class name.
 */
export default function ClassList({ classes = [], activeId, onSelect, loading = false, getMeta }) {
    if (loading && classes.length === 0) {
        return (
            <div className="flex gap-2 overflow-hidden lg:flex-col">
                {[0, 1, 2, 3].map((key) => (
                    <div
                        key={key}
                        className="h-10 w-28 shrink-0 animate-pulse rounded-lg bg-slate-200/70 lg:w-full"
                    />
                ))}
            </div>
        )
    }

    return (
        <nav
            aria-label="Classes"
            className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 lg:mx-0 lg:flex-col lg:overflow-visible lg:px-0 lg:pb-0"
        >
            {classes.map((item) => {
                const active = item.id === activeId
                const meta = getMeta?.(item)
                return (
                    <button
                        key={item.id}
                        type="button"
                        aria-current={active ? "true" : undefined}
                        onClick={() => onSelect(item)}
                        className={[
                            "group flex shrink-0 items-center gap-3 rounded-lg border px-3 py-2 text-left text-sm transition-colors",
                            "focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
                            active
                                ? "border-indigo-200 bg-indigo-50 font-semibold text-indigo-700"
                                : "border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50"
                        ].join(" ")}
                    >
                        <span
                            className={[
                                "hidden h-8 w-8 shrink-0 items-center justify-center rounded-md lg:flex [&>svg]:h-[18px] [&>svg]:w-[18px]",
                                active
                                    ? "bg-indigo-600 text-white"
                                    : "bg-slate-100 text-slate-500 group-hover:bg-slate-200"
                            ].join(" ")}
                        >
                            <SchoolOutlined />
                        </span>
                        <span className="min-w-0">
                            <span className="block whitespace-nowrap lg:truncate">{item.class_name}</span>
                            {meta && (
                                <span className={`block whitespace-nowrap text-xs font-normal ${active ? "text-indigo-500" : "text-slate-400"}`}>
                                    {meta}
                                </span>
                            )}
                        </span>
                    </button>
                )
            })}
        </nav>
    )
}
